export const CAPITAL_PURCHASE_ID = 'CAPITAL_PURCHASE';
export const CAPITAL_PURCHASE_NAME = 'Capital Purchase';

export const CAPITAL_PURCHASE_OPTION = {
  id: CAPITAL_PURCHASE_ID,
  name: CAPITAL_PURCHASE_NAME
};
